module.exports = __webpack_public_path__ + "img/engagement@2x.d4cf98d.jpg";